<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Crear operador</h5>
          <button type="button" @click="closeModal" style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="form-group">
              <label for="code-input">Código:</label>
              <input type="text" class="form-control" id="code-input" v-model="form.code" required ref="firstInput" />
            </div>
            <div class="form-group mt-2">
              <label for="name-input">Nombre:</label>
              <input type="text" class="form-control" id="name-input" v-model="form.name" required />
            </div>
            <div class="form-group mt-2">
              <label for="surname-input">Apellidos:</label>
              <input type="text" class="form-control" id="surname-input" v-model="form.surname" required />
            </div>
            <div class="form-group mt-2">
              <label for="email-input">Correo Electrónico:</label>
              <input type="email" class="form-control" id="email-input" v-model="form.email" required />
            </div>
            <div class="form-group mt-2">
              <label for="phone-input">Teléfono:</label>
              <input type="number" class="form-control" id="phone-input" v-model="form.phone" required />
            </div>
            <div class="form-group mt-2">
              <label for="operator-title-select">Puesto:</label>
              <select id="operator-title-select" class="form-control" v-model.number="form.operator_title_id" required >
                <option v-for="title in operatorTitles" :value="title.id" :key="title.id">
                  {{ title.descrip }}
                </option>
              </select>
            </div>
            <hr>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-danger me-2" @click="closeModal">Cancelar</button>
              <button type="submit" class="btn btn-success">Crear</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
  name: 'OperatorCreateModal',
  props: {

  },
  data() {
    return {
      operatorTitles: [],
      form: {
        code: '',
        name: '',
        surname: '',
        email: '',
        phone: '',
        operator_title_id: '',
        annual_base_salary: 0
      }
    };
  },
  mounted() {
    this.loadSelectOperatorTitles();
  },
  methods: {
    loadSelectOperatorTitles() {
      axios.get('/api/operator-titles')
        .then(response => {
          this.operatorTitles = response.data;
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    submitForm() {
      axios.post('/api/operator', this.form)
        .then(() => {
          showCustomSuccessSweetAlert('Operador creado correctamente');
          this.$emit('operator-created');
          this.closeModal();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },   
    closeModal() {
      this.$emit('close-modal');
    },
  }
};
</script>